import effectManager from '../../module/effect';

let effect = new effectManager();

export default class ThumSlide {
    constructor() {

        this.$day18 = $("#p-act-day_18 .p-act-day-thum-bg-img")
        this.$day19 = $("#p-act-day_19 .p-act-day-thum-bg-img")

        effect.bgImg(this.$day18,"set");
        effect.bgImg(this.$day19,"set");
        effect.bgImg(this.$day18.eq(0).find(">* >*"),"show");
        effect.bgImg(this.$day19.eq(0).find(">* >*"),"show");

        this.status = {
            start : false,
            prev : 18,
            day18 : {
                current : 0,
                time    : 1
            },
            day19 : {
                current : 0,
                time    : 1
            }
        }

        this.conf = {
            day18 : {
                PAUSE : 240,
                MAX : 2,
            },
            day19 : {
                PAUSE : 240,
                MAX : 2,
            }
        }


    }
    render(select){


        let _day = {
            $t   : select===18 ? this.$day18 : this.$day19,
            conf : select===18 ? this.conf.day18 : this.conf.day19,
            status : select===18 ? this.status.day18 : this.status.day19,
        }

        if(this.status.prev!=select) _day.status.time = 241;
        this.status.prev=select;

        if(_day.conf.PAUSE<_day.status.time||_day.status.time==0){

            if(_day.status.time!==0) {
                effect.bgImg(_day.$t.eq(_day.status.current).find(">* >*"),"out");
                _day.status.current = _day.status.current < _day.conf.MAX ? _day.status.current+1 : 0;
            }

            effect.bgImg(_day.$t.eq(_day.status.current).find(">* >*"),"show");
            _day.status.time = 1;

        }
        _day.status.time ++;
    }
    resize(w){

    }
}